import * as React from "react"
import { cn } from "../../lib/cn"
import { cva } from "class-variance-authority"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap sahi-radius text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none   disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-sahi-primary-color text-primary-foreground hover:bg-primary-foreground hover:text-sahi-primary-color border border-transparent hover:border-sahi-primary-color",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border sahi-radius border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-white sahi-radius text-sahi-primary-color border border-sahi-primary-color hover:text-primary-foreground hover:bg-sahi-primary-color",
        sahiGreen: "bg-sahi-green text-white border  border-transparent hover:bg-sahi-green hover:brightness-110  hover:shadow-md  hover:-translate-y-0.5 active:translate-y-0 active:brightness-95 transition-all  duration-200  ease-in-out",
        sahiDarkBlue: "bg-sahi-dark-blue text-white border  border-transparent hover:bg-sahi-dark-blue hover:brightness-110  hover:shadow-md  hover:-translate-y-0.5 active:translate-y-0 active:brightness-95 transition-all  duration-200  ease-in-out",
        ghost: "",
        link: "text-primary underline-offset-4 hover:underline",
        additional: "bg-sahi-primary-color text-white text-base sahi-primary-button py-[6px] px-[10px] sahi-radius",
        semidefault: "bg-sahi-primary-color text-primary-foreground  border border-transparent hover:border-sahi-primary-color",
        noHoversemidefault: "bg-sahi-primary-color text-primary-foreground  border border-transparent ",
        semidefaultcol: "bg-sahi-primary-color text-primary-foreground  border border-transparent",
        iconOnly: "bg-transparent border-none cursor-pointer hover:opacity-60 transition-opacity duration-200 [&_svg]:!size-5 text-sahi-primary-color",
        outlinefiliter: "border sahi-radius border-input bg-background",
      },
      size: {
        default: "h-10 sahi-radius px-2 py-2",
        sm: "h-6 sahi-radius px-2",
        lg: "h-11 sahi-radius px-8",
        icon: "h-8 w-8",
        pgn: "h-9 sahi-radius px-3",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({
  className,
  variant = "primary",
  size = "default",
  ...props
}, ref) => {
  const variants = {
    primary: "bg-primary hover:bg-primary-dark text-white font-normal shadow-button hover:shadow-button-hover  [background-image:linear-gradient(90deg,rgba(255,255,255,0.1)_0%,rgba(0,0,0,0.1)_100%)]",
    secondary: "bg-white hover:bg-background-light text-primary border border-primary font-semibold shadow-md hover:shadow-lg ",
    primaryDarkBlue: "bg-darkBlue hover:bg-darkBlue-dark text-white font-normal shadow-button hover:shadow-button-hover [background-image:linear-gradient(90deg,rgba(255,255,255,0.1)_0%,rgba(0,0,0,0.1)_100%)]",
    secondaryDarkBlue: "bg-white hover:bg-darkBlue text-darkBlue hover:text-white border border-darkBlue font-semibold shadow-button shadow-md hover:shadow-button-hover",
    outline: "border-2 border-primary text-primary hover:bg-primary hover:text-white font-semibold",
    outlineDarkBlue: "border-2 border-darkBlue text-darkBlue hover:bg-darkBlue hover:text-white font-semibold",
    ghost: "text-primary hover:bg-primary/10 font-semibold",
  }
  const sizes = {
    // Increased padding and text size for desktop (md and up)
    default: "px-[18px] py-[10px] text-base md:px-[24px] md:py-[12px] md:text-lg",
    xs: "px-3.5 py-1.5 text-sm md:px-5 md:py-2.5 md:text-sm",
    sm: "px-4 py-2 text-sm md:px-6 md:py-3 md:text-base",
    lg: "px-12 py-4 text-lg md:px-12 md:py-4 md:text-xl",
  }

  return (
    <button
      className={cn(
        "inline-flex items-center justify-center rounded transition-all duration-300",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        "focus:outline-none focus:ring-2 focus:ring-primary/20",
        variants[variant],
        sizes[size],
        className
      )}
      ref={ref}
      {...props}
    />
  )
})

Button.displayName = "Button"

export { Button, buttonVariants }